import React from 'react';
import { LocalizedMessage } from 'core/l10n/components';
import { FormGroup, Input, Label } from 'reactstrap';
import RewardCalculation from 'core/ovations-api/definitions/rewards/RewardCalculation';
import RewardPackage from 'core/ovations-api/definitions/RewardPackage';

export interface RewardOptionSelectProps {
    rewardCalculations?: RewardCalculation[];
    renderRewardOptionSelectionErrorBanner?: () => JSX.Element | null;
    rewardOptionIsChecked: (rewardCalc: RewardCalculation, rewardPackage: RewardPackage) => boolean | undefined;
    changeRewardOption: (rewardCalc: RewardCalculation, rewardPackage: RewardPackage) => void;
    disabled?: boolean;
    required?: boolean;
}

const RewardOptionSelect = (props: RewardOptionSelectProps) => {
    if (!props.rewardCalculations) {
        return <>empty</>;
    }

    const errorBanner = props.renderRewardOptionSelectionErrorBanner
        ? props.renderRewardOptionSelectionErrorBanner()
        : '';

    return (
        <>
            {props.rewardCalculations.map((rewardCalc) => (
                <>
                    {errorBanner}
                    <div className="mb-2">
                        <strong>
                            <LocalizedMessage id="claimFormStep_RewardOptionSelectionHeader" />
                        </strong>
                    </div>{' '}
                    {rewardCalc.rewardPackages.map((rewardPackage, i) => (
                        <div key={`${rewardPackage.id}_${rewardCalc.id}_${i}`} className="me-4 pe-4">
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        disabled={props.disabled}
                                        name={rewardCalc.id.toString()}
                                        required={props.required === undefined ? true : props.required}
                                        type="radio"
                                        checked={props.rewardOptionIsChecked(rewardCalc, rewardPackage)}
                                        onChange={() => props.changeRewardOption(rewardCalc, rewardPackage)}
                                    />{' '}
                                    {rewardPackage.customerFacingName
                                        ? rewardPackage.customerFacingName
                                        : rewardPackage.name}
                                </Label>
                            </FormGroup>
                        </div>
                    ))}
                </>
            ))}
        </>
    );
};

export default RewardOptionSelect;
